export default __webpack_public_path__ + "static/media/arrow.f979208a.gif";